export default "__VITE_ASSET__C4A2SOO3__"